import saas from '@/utils/saas'
import requestByQuesion from '@/api/security/requestByQuesion'

/** *
 * 封装请求参数、请求路径
 */
function createRequest(service, api, data, xUserAction) {
  data = saas.data(service, api, data)
  if (xUserAction) {
    data.xUserAction = xUserAction
  }
  return requestByQuesion({
    url: saas.Constant.GATEWAY_URL + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}

// 设置密保问题
export function submitDada(data) {
  return createRequest(saas.ServiceName.CUSTOMER_API, 'customer_set_security_question', data, '设置密保问题')
}

// 查询密保问题
export function getEncryptData(data) {
  return createRequest(saas.ServiceName.CUSTOMER_API, 'customer_search_security_question', data, '查询密保问题')
}

// 校验密保
export function nextCheckQuestion(data) {
  return createRequest(saas.ServiceName.CUSTOMER_API, 'customer_check_security_question', data, '校验密保问题')
}

// 获取短信验证码
export function getSmsCode(data) {
  return createRequest(saas.ServiceName.DICT_API, 'SEND_SMS', data, '获取短信验证码')
}

